export default "__VITE_ASSET__BjVIZrgL__"